import { StoreLocaleCodeSchema, type LocaleCode } from './types';

export function isStoreLocaleCode(code: string): code is LocaleCode {
   return StoreLocaleCodeSchema.safeParse(code).success;
}

export function isEULocale(locale?: LocaleCode): boolean {
   if (!locale) return false;
   const euLocales: LocaleCode[] = ['en-gb', 'en-eu', 'fr-fr', 'de-de', 'it-it'];
   return euLocales.includes(locale);
}
